import React from "react";
import { PrintersRegistryInfo } from "@grabcad/company-server-shared/dist/types";
import PrinterCard from "./PrinterCard/PrinterCard";
import { CardGrid, GridWrapper } from "./PrinterCardGridStyle";

export type PrinterCardItem = PrintersRegistryInfo & {
    imageUri?: string;
};

interface Props {
    printers: PrinterCardItem[];
}

const PrinterCardGrid: React.FC<Props> = ({ printers }) => (
    <GridWrapper>
        <CardGrid>
            {printers.map((printer) => (
                <PrinterCard
                    key={printer.serial}
                    {...printer}
                    lastSeenOn={printer.lastSeenOn || {}}
                />
            ))}
        </CardGrid>
    </GridWrapper>
);

export default PrinterCardGrid;
